module.exports = __webpack_public_path__ + "img/faarm.7d1b4f9e.svg";